import { useTranslation } from '@thoughtspot/i18n';
import { Alert } from '@thoughtspot/radiant-react/widgets/alert';
import { ErrorCode } from '@thoughtspot/radiant-react/widgets/alert/alert-constants';
import { IconID } from '@thoughtspot/radiant-react/widgets/icon';
import { Input } from '@thoughtspot/radiant-react/widgets/input';
import { TableListView } from '@thoughtspot/radiant-react/widgets/table/table-list-view';
import React, { useEffect, useMemo, useState } from 'react';
import { GitConfigsSortFieldName, GitConfigsSortOrder, } from "../../../services/generated/graphql-types";
import { useGetGitConfig } from "../../../services/version-control/version-control";
import { Vertical } from "../../../utils/layouts";
import { TranslationKeys } from '../constant';
import styles from './all-org-configuration-details.module.scss';
import { getColumnDefinitions, ListActionTypes, parseOrgsConfigData, SortingType, sortKeyMap, } from './all-orgs.utils';
export const AllOrgConfigurationDetails = ({ openConfigModalForEdit, onConfigReset, onEnableVersionControl, }) => {
    const { t } = useTranslation();
    const [orgsSearchText, setSearchText] = useState('');
    const [loading, setLoading] = useState(true);
    const [configDetails, setConfigDetails] = useState([]);
    const parsedConfigData = useMemo(() => parseOrgsConfigData(configDetails), [configDetails]);
    const [configFetchParams, setConfigFetchParams] = useState({
        sort_options: {
            field_name: GitConfigsSortFieldName.Name,
            order: GitConfigsSortOrder.Asc,
        },
        offset: -1,
        batchsize: -1,
        name_pattern: '',
    });
    const { data: getConfigData, error: getConfigError, loading: configLoading, fetchGitConfig, } = useGetGitConfig(configFetchParams);
    useEffect(() => {
        if (getConfigData && !configLoading) {
            setLoading(false);
            setConfigDetails(getConfigData.data);
        }
        if (configLoading) {
            setLoading(true);
        }
    }, [getConfigData, getConfigError, configLoading]);
    useEffect(() => {
        fetchGitConfig(configFetchParams);
    }, [configFetchParams]);
    useEffect(() => {
        setConfigFetchParams({
            ...configFetchParams,
            name_pattern: `%${orgsSearchText}%`,
        });
    }, [orgsSearchText]);
    const onSortingChanged = (sortState) => {
        const sortingColumn = sortState[0];
        const field_name = sortKeyMap[sortingColumn.colId];
        const order = sortingColumn.sort === SortingType.ASC
            ? GitConfigsSortOrder.Asc
            : GitConfigsSortOrder.Desc;
        setConfigFetchParams({
            ...configFetchParams,
            name_pattern: `%${orgsSearchText}%`,
            sort_options: {
                field_name,
                order,
            },
        });
    };
    const onRowActionCB = ({ action, data: actionData }) => {
        if (action === ListActionTypes.EDIT) {
            openConfigModalForEdit(actionData?.id?.toString());
        }
        else if (action === ListActionTypes.RESET) {
            onConfigReset(actionData?.id?.toString());
        }
        else {
            onEnableVersionControl(actionData?.id?.toString());
        }
    };
    const renderSearchBar = () => {
        return (React.createElement(Input.Text, { ariaLabel: t(TranslationKeys.VCS_FILTER_SEARCH_TEXT), placeholder: t(TranslationKeys.VCS_FILTER_SEARCH_TEXT), type: "text", value: orgsSearchText, onChange: e => setSearchText(e.target.value), prefixIcon: IconID.MAGNIFYING_GLASS, suffixIcon: orgsSearchText ? IconID.CROSS : null, onSuffixIconClick: () => {
                setSearchText('');
            }, className: styles.orgSearchInput }));
    };
    return (React.createElement(Vertical, { className: styles.allOrgConfigurationDetails },
        renderSearchBar(),
        (parsedConfigData.length > 0 || loading) && (React.createElement(TableListView, { options: {}, loading: loading, columns: getColumnDefinitions(), data: parsedConfigData, onSortingChanged: onSortingChanged, agGridContext: { onRowAction: onRowActionCB }, className: styles.orgsConfigTable, headerHeight: 36 })),
        React.createElement(Alert.Muted, { isVisible: !loading && parsedConfigData.length === 0, title: t(TranslationKeys.VCS_ADMIN_NO_MATCH_MSG), description: "", errorCode: ErrorCode.GLOBAL_DATA, "data-testid": "no-data-alert", global: true, imageVisible: true, className: styles.alertNoMatchBanner })));
};
//# sourceMappingURL=all-org-configuration-details.js.map